import React, { useState, useRef, useMemo, useEffect } from "react";
import JoditEditor from "jodit-react";
import { uploadFileApi } from "../../../utils/ApiEndpointFunctions";
import toast from "react-hot-toast";
import { convertByteToMB } from "../../../utils/HelperFuncitons";
import Spinwheel from "../../common/Spinwheel";
import { S3_URL } from "../../../utils/BaseUrl";

const AddOrUpdateLearning = ({ isOpen, onClose, formik, loading, modalId }) => {
  const [type, setType] = useState('video')
  const fileInputRef = useRef(null);
  const videoFileInputRef = useRef(null);
  const fileUploadHandler = async (e) => {
    try {
      const FILE_ACCEPT = ["image/jpg", "image/jpeg", "image/png"];

      console.log("e.target.value", e.target.value);

      const file = e.target.files[0];
      if (file) {
        if (!FILE_ACCEPT.includes(file.type)) {
          toast.error("Invalid File Format");
          return;
        }

        const fileSizeInMB = convertByteToMB(file.size || 0);

        if (fileSizeInMB > 5) {
          return toast.error("File Size Exceeds. Max Image Should be of 5 MB");
        }

        formik.setFieldTouched("thumbnail", true);
        const formData = new FormData();
        formData.append("file", file);
        formData.append("type", "web");

        const res = await uploadFileApi(formData);
        if (res.status === 200 && res.data?.status === 1) {
          toast.success("File uploaded");
          formik.setFieldValue("thumbnail", res.data?.data);
        }
      }
    } catch (error) {
      console.log(error);
      if (error?.response === undefined) {
        toast.error(
          "There was an error uploading your file. Please try again later."
        );
      }
    }
  };

  const [videoUploading, setVideoUploading] = useState(false);
  const videoFileUploadHandler = async (e) => {
    try {
      const FILE_ACCEPT = ["video/mp4", "video/mkv", "video/webm", "video/ogg", "video/avi"];

      const file = e.target.files[0];
      if (file) {
        if (!FILE_ACCEPT.includes(file.type)) {
          toast.error("Invalid Video Format");
          return;
        }

        const fileSizeInMB = convertByteToMB(file.size || 0);

        if (fileSizeInMB > 300) {
          return toast.error("File size exceeds. Max video size should be 300 MB");
        }

        formik.setFieldTouched("video", true);
        setVideoUploading(true);

        const formData = new FormData();
        formData.append("file", file);
        formData.append("type", "web"); // You can update this type if needed

        try {
          const res = await uploadFileApi(formData);
          if (res.status === 200 && res.data?.status === 1) {
            toast.success("Video uploaded");
            formik.setFieldValue("video", res.data?.data);
          }
        } finally {
          setVideoUploading(false);
        }
      }
    } catch (error) {
      setVideoUploading(false);
      console.error(error);
      if (error?.response === undefined) {
        toast.error(
          "There was an error uploading your video. Please try again later."
        );
      }
    }
  };

  const editor = useRef(null);

  console.log(formik?.values);

  return (
    <div
      className={`modal fade ${isOpen ? "show" : ""}`}
      id={modalId}
      tabIndex="-1"
      aria-labelledby="addOrUpdateModalId"
      aria-hidden={!isOpen}
      style={{ display: isOpen ? "block" : "none" }}
      role={isOpen ? "dialog" : undefined}
    >
      <div className="modal-dialog modal-xl">
        <div className="modal-content" style={{backgroundColor:"rgb(250 250 250)"}}>
          <div className="modal-header">
            <h5 className="modal-title" id="blogAddModalLabel">
              {formik?.values?.id ? "Update" : "Add"}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            <form onSubmit={formik?.handleSubmit}>
              <div className="row mb-3">
                <div className="d-flex justify-content-between align-items-center " >
                  <div className="mb-3 me-3 col-md-6">
                    <label htmlFor="type" className="form-label">Type</label>
                    <select
                      className="form-control w-100"
                      id="type"
                      name="type"
                      value={formik?.values?.type}
                      onChange={formik?.handleChange}
                      onBlur={formik?.handleBlur}
                    >
                      <option value="">Select</option>

                      <option value="video">Video</option>
                      <option value="article">Article</option>

                    </select>
                    {formik?.touched?.type && formik?.errors?.type ? (
                      <div className='req-error'>{formik?.errors?.type}</div>
                    ) : null}
                  </div >
                   <div className="mb-3 me-2 col-md-3">
                    <label htmlFor="language" className="form-label">Language</label>
                    <select
                      className="form-control w-100"
                      id="language"
                      name="language"
                      value={formik?.values?.language}
                      onChange={formik?.handleChange}
                      onBlur={formik?.handleBlur}
                    >
                      <option value="">Select</option>

                      <option value="en">English</option>
                      <option value="fr">French</option>

                    </select>
                    {formik?.touched?.language && formik?.errors?.language ? (
                      <div className='req-error'>{formik?.errors?.language}</div>
                    ) : null}
                  </div >
                  <div className="col-md-3">
                    <label htmlFor="isPublish" className="form-label">
                      Published
                    </label>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        // checked={formik?.values?.isPublish}
                        role="switch"
                        id="isPublish"
                        name="isPublish"
                        onChange={() =>
                          formik.setFieldValue(
                            "isPublish",
                            !formik?.values?.isPublish
                          )
                        }
                        checked={formik.values.isPublish}
                      // onChange={(e) =>
                      //   formik.setFieldValue("isPublish", e.target.checked)
                      // }
                      />
                    </div>
                  </div>

                </div>
                <div className="col-md-6">
                  <label htmlFor="title" className="form-label">
                    Title:
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="title"
                    name="title"
                    placeholder="Enter"
                    value={formik?.values?.title}
                    onChange={formik?.handleChange}
                    onBlur={formik?.handleBlur}
                  />
                  {formik?.touched?.title && formik?.errors?.title ? (
                    <div className="req-error">{formik?.errors?.title}</div>
                  ) : null}
                </div>

                {
                  formik.values.type === "video" && (
                    <div className="col-md-6">
                      <label htmlFor="description" className="form-label">
                        Description:
                      </label>
                      <textarea className="form-control" name="description" id="description" placeholder="Enter" rows={1} value={formik?.values?.description} onChange={formik?.handleChange} onBlur={formik?.handleBlur}>

                      </textarea>
                      {/* <input
                    type="text"
                    className="form-control"
                    id="description"
                    name="description"
                    placeholder="Enter"
                    value={formik?.values?.description}
                    onChange={formik?.handleChange}
                    onBlur={formik?.handleBlur}
                  /> */}
                      {formik?.touched?.description && formik?.errors?.description ? (
                        <div className="req-error">{formik?.errors?.description}</div>
                      ) : null}
                    </div>
                  )
                }

                <div className="col-md-6">
                  <label className="form-label fw-semibold">Thumbnail</label>
                  <div
                    className="border rounded d-flex justify-content-center align-items-center bg-light"
                    style={{
                      cursor: "pointer",
                      minHeight: "250px",
                      position: "relative",
                      overflow: "hidden",
                    }}
                    onClick={() => fileInputRef.current?.click()}
                  >
                    {/* Preview Image (only when selected) */}
                    {formik.values?.thumbnail ? (
                      <img
                        src={S3_URL + "/" + formik.values.thumbnail}
                        alt="Preview"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          position: "absolute",
                          top: 0,
                          left: 0,
                        }}
                      />
                    ) : (
                      <span className="text-muted">Choose a file</span>
                    )}
                  </div>

                  <input
                    type="file"
                    className="d-none"
                    ref={fileInputRef}
                    name="thumbnail"
                    onChange={fileUploadHandler}
                    onBlur={formik.handleBlur}
                  />

                  {formik?.touched?.thumbnail && formik?.errors?.thumbnail && (
                    <div className="text-danger mt-1">
                      {formik?.errors?.thumbnail}
                    </div>
                  )}
                </div>

                {
                  formik.values.type === "video" && (
                    <div className="col-md-6">
                      <label className="form-label fw-semibold">Video file</label>
                      <div
                        className="border rounded d-flex justify-content-center align-items-center bg-light"
                        style={{
                          minHeight: "250px",
                          position: "relative",
                          overflow: "hidden",
                        }}
                      >
                        {videoUploading ? (
                          <div className="d-flex justify-content-center align-items-center w-100 h-100" style={{ minHeight: "250px" }}>
                            <Spinwheel sizeClass="spin-large" />
                          </div>
                        ) : formik.values?.video ? (
                          <video
                            src={S3_URL + "/" + formik.values.video}
                            controls
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              position: "absolute",
                              top: 0,
                              left: 0,
                            }}
                          />
                        ) : (
                          <span className="text-muted">No video selected</span>
                        )}
                      </div>
                      <div className="mt-2 d-flex justify-content-start">
                        <button
                          type="button"
                          className="btn btn-outline-primary"
                          onClick={() => !videoUploading && videoFileInputRef.current?.click()}
                          disabled={videoUploading}
                        >
                          {formik.values?.video ? "Change Video" : "Upload Video"}
                        </button>
                      </div>
                      <input
                        type="file"
                        className="d-none"
                        ref={videoFileInputRef}
                        name="video"
                        onChange={videoFileUploadHandler}
                        onBlur={formik.handleBlur}
                        disabled={videoUploading}
                      />
                      {formik?.touched?.video && formik?.errors?.video && (
                        <div className="text-danger mt-1">
                          {formik?.errors?.video}
                        </div>
                      )}
                    </div>
                  )
                }
              </div>
              {
                formik.values.type === "video" && (
                  <div>

                    <div className="mb-3">
                      <label htmlFor="additionalMaterial" className="form-label">
                        Additional Material:
                      </label>
                      <JoditEditor
                        ref={editor}
                        value={formik?.values?.additionalMaterial}
                        // config={config}
                        onBlur={(e) => {
                          formik.setFieldTouched("additionalMaterial", true);
                          e === "<p><br></p>"
                            ? formik.setFieldValue("additionalMaterial", "")
                            : formik.setFieldValue("additionalMaterial", e);
                        }}
                        onChange={(newContent) => { }}
                      />
                      {formik?.touched?.additionalMaterial && formik?.errors?.additionalMaterial ? (
                        <div className="req-error">{formik?.errors?.additionalMaterial}</div>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <label htmlFor="answers" className="form-label">
                        Answers to the lesson:
                      </label>
                      <JoditEditor
                        ref={editor}
                        value={formik?.values?.answers}
                        // config={config}
                        onBlur={(e) => {
                          formik.setFieldTouched("answers", true);
                          e === "<p><br></p>"
                            ? formik.setFieldValue("answers", "")
                            : formik.setFieldValue("answers", e);
                        }}
                        onChange={(newContent) => { }}
                      />
                      {formik?.touched?.answers && formik?.errors?.answers ? (
                        <div className="req-error">{formik?.errors?.answers}</div>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <label htmlFor="notes" className="form-label">
                        Notes:
                      </label>
                      <JoditEditor
                        ref={editor}
                        value={formik?.values?.notes}
                        // config={config}
                        onBlur={(e) => {
                          formik.setFieldTouched("notes", true);
                          e === "<p><br></p>"
                            ? formik.setFieldValue("notes", "")
                            : formik.setFieldValue("notes", e);
                        }}
                        onChange={(newContent) => { }}
                      />
                      {formik?.touched?.notes && formik?.errors?.notes ? (
                        <div className="req-error">{formik?.errors?.notes}</div>
                      ) : null}
                    </div>
                  </div>
                )
              }

              {
                formik.values.type === "article" && (
                  <div className="mb-3">
                    <label htmlFor="content" className="form-label">
                      Content
                    </label>
                    <JoditEditor
                      ref={editor}
                      value={formik?.values?.content}
                      // config={config}
                      onBlur={(e) => {
                        formik.setFieldTouched("content", true);
                        e === "<p><br></p>"
                          ? formik.setFieldValue("content", "")
                          : formik.setFieldValue("content", e);
                      }}
                      onChange={(newContent) => { }}
                    />
                    {formik?.touched?.content && formik?.errors?.content ? (
                      <div className="req-error">{formik?.errors?.content}</div>
                    ) : null}
                  </div>
                )
              }

              <button
                type="submit"
                className="btn btn-primary mb-4"
                disabled={loading}
              >
                {loading ? <Spinwheel sizeClass={"spin-small"} /> : "Submit"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddOrUpdateLearning;